import { createContext } from 'react';

export const LegalDocumentsContext = createContext(undefined);
export const LegalDocumentsProvider = LegalDocumentsContext.Provider;
